import { VarHelper } from "common-import/helpers";
import { HOST_WEB } from "common-import/constants";
const { urlSlug } = VarHelper;

class RouterStore {

  web = {
    contractorDetail: (id, name) => `${HOST_WEB}/contractor/${id}/${urlSlug(name)}`,
    projectDetail: (id, name) => `${HOST_WEB}/project/${id}/${urlSlug(name)}`,
    biddingDetail: (id, name) => `${HOST_WEB}/bidding/${id}/${urlSlug(name)}`,
    productDetail: (id, name) => `${HOST_WEB}/product/${id}/${urlSlug(name)}`,
    orderDetail: (id, name) => `${HOST_WEB}/order/${id}/${urlSlug(name)}`,
  };

  admin = {
    contractorDetail: (id, name) => `/contractor/${id}?name=${name}`,
    projectDetail: (id, name) => `/project/${id}?name=${name}`,
    biddingDetail: (id, name) => `/bidding/${id}?name=${name}`,
    productDetail: (id, name) => `/product/${id}?name=${name}`,
    orderDetail: (id, name) => `/order/${id}?name=${name}`,
  };

}

export default new RouterStore();



// WEBPACK FOOTER //
// ./src/services/RouteStore.js